<template>
  <div>

    <loading v-show="showLoading"></loading>

    <div v-show="!showLoading" >

      <div class="after-commit-content">
        <div class="after-commit-each">
          <div class="after-commit-goods">
            <div class="after-commit-goods-each">
              <div class="after-commit-goods-left">
                <van-image :src="imageUrl" fit="cover"></van-image>
              </div>
              <div class="after-commit-goods-right">
                <div>
                  <div class="after-commit-goods-name">
                    {{productName}}
                  </div>
                  <div class="after-commit-goods-num">
                    x{{goodsCnt}}
                  </div>
                </div>
                <div class="after-commit-goods-div-bottom">
                  <div class="after-commit-goods-price">
                    ¥{{price}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="after-commit-div">
        <div class="after-commit-div-title">
          退货数量
        </div>
        <div class="after-commit-div-value">
          <button class="after-commit-div-value-button"  @click="lowNum()">
            -
          </button>
          <div class="after-commit-div-value-div">{{quantity}}</div>
          <button class="after-commit-div-value-button" @click="addNum()">
            +
          </button>
        </div>
      </div>

      <div class="after-commit-div" v-show="isReturns == 'Y'">
        <div class="after-commit-div-title">
          货物状态
        </div>
        <div class="after-commit-div-value">
          <span class="zt14 themeColor" style="width: 4rem;margin-right: 1rem" @click="selectStatus()">{{currentStatus ==''?'请选择':currentStatus}}<img class="open_btn" style="position: absolute;margin-top: 1rem" src="@/images/icon_arrow_Put away@3x.png"></span>
          <van-action-sheet v-model="showStatus" :actions="statusList" @select="onSelectStatus" />
        </div>
      </div>

      <div class="after-commit-upload">
        <div class="after-commit-upload-div">
          <div class="zt14 themeColor after-commit-reason" style="width: 20.5rem;padding: 0 0.5rem" @click="selectReasons()"><span style="width: 15rem">{{currentReason ==''?'请选择':currentReason}}</span><img class="open_btn fr" style="margin-top: 0.5rem" src="@/images/icon_arrow_Put away@3x.png"></div>
          <van-action-sheet v-model="showResons" :actions="reasonList" @select="onSelectReasons" />
        </div>
        <div class="after-commit-upload-div">
          <textarea ref="detailReason" placeholder="请描述申请售后的具体原因" class="after-commit-text" maxlength="200"></textarea>
        </div>
        <div class="after-commit-upload-div">
          <div class="after-commit-photo-title">
            上传图片(最多3张)
          </div>
          <div class="after-commit-photo-list">
            <van-uploader v-model="fileList" multiple :max-count="3" :after-read="afterRead"/>
          </div>
        </div>
      </div>

      <div class="after-commit-info" v-show="isReturns == 'Y'">

        <div class="after-commit-info-div">
          <div class="after-commit-info-title">
            姓名
          </div>
          <div class="after-commit-info-value">
            <input ref="partyName" placeholder="请输入姓名(必填)" type="text"/>
          </div>
        </div>

        <div class="after-commit-info-div">
          <div class="after-commit-info-title">
            手机
          </div>
          <div class="after-commit-info-value">
            <input ref="phone" placeholder="请输入手机(必填)" type="number"/>
          </div>
        </div>

      </div>

      <div class="after-commit-button">
        <button @click="commitApplyInfo()">提交</button>
      </div>


    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId,loginInfo } from '@/router/Constant'
  import { getAfterOrderLogistics,getAfterSaleReasonList,uploadFile } from '@/router/api'
  import { NavBar,Image, Grid,Button, Tabbar, Toast,PullRefresh,Dialog,Uploader,ActionSheet,Overlay} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie,getDrawImageFile } from '@/utils/mUtil';
  import refresh from '@/components/page/common/refresh.vue';
  export default {
    name: "afterCommit",
    data(){
      return{
        showResons:false,
        showStatus:false,
        showLoading:true,
        imageUrl:this.$route.query.imageUrl,
        price:this.$route.query.price,
        quantity:this.$route.query.quantity,
        productName:this.$route.query.productName,
        isReturns:this.$route.query.isReturns,
        orderId:this.$route.query.orderId,
        typeId:this.$route.query.typeId,
        productId:this.$route.query.productId,
        goodsCnt:this.$route.query.quantity,
        orderItemSeqId:this.$route.query.orderItemSeqId,
        reasonList:[],
        statusList:[
          {name:"未收货"},
          {name:"已收货"},
        ],
        currentReason:'',
        currentReasonId:'',
        currentStatus:'',
        fileList: [],
        images:'',
      }
    },

    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Button.name]: Button,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [PullRefresh.name]: PullRefresh,
      loading,
      refresh,
      [Dialog.Component.name]: Dialog.Component,
      [Uploader.name]:Uploader,
      [ActionSheet.name]: ActionSheet,
      [Overlay.name]: Overlay,
    },

    methods: {

      async initData() {
        this.getAfterSaleReasonList();
      },

      onSelectStatus(item) {
        // 默认情况下，点击选项时不会自动关闭菜单
        // 可以通过 close-on-click-action 属性开启自动关闭
        this.showStatus = false;
        this.currentStatus = item.name
      },

      onSelectReasons(item) {
        // 默认情况下，点击选项时不会自动关闭菜单
        // 可以通过 close-on-click-action 属性开启自动关闭
        this.showResons = false;
        this.currentReason = item.name;
        this.currentReasonId = item.reasonId;
      },

      lowNum() {
        if (this.quantity >1 && this.isReturns == 'Y') {
          this.quantity --;
        }
      },

      addNum() {
        if (this.quantity < this.$route.query.quantity && this.isReturns == 'Y') {
          this.quantity ++;
        }
      },

      selectStatus(){
        this.showStatus = true;
      },

      selectReasons(){
        this.showResons = true;
      },

      getAfterSaleReasonList(){
        var reasonTypeId = ""
        if (this.isReturns == 'Y') {
          reasonTypeId = 'COMMON';
        } else if (this.isReturns == 'N') {
          reasonTypeId = 'DIGITAL';
        }
        getAfterSaleReasonList({externalLoginKey:getStore('externalLoginKey'),reasonTypeId:reasonTypeId})
          .then(res => {
            console.log("getAfterSaleReasonList")
            console.log(res)
            if (res.reasonList.length > 0) {
              for (var i=0;i< res.reasonList.length;i ++ ) {
                var item = {'name':res.reasonList[i].reasonName,'reasonId':res.reasonList[i].reasonId}
                this.reasonList.push(item)
              }
            }
            setTimeout(() => {
              this.showLoading = false;
              this.isLoading = false;
            }, 1000);
          })
          .catch(err => {
            console.log(err);
          });
      },

      afterRead:function(file){
        getDrawImageFile(file);
      },

      upload:function (file) {
        var param = {
          files:file,
          formType:'afterOrder',
          externalLoginKey:this.token
        }
        uploadFile(param)
          .then(res => {
            console.log(res);
            if(res.pathList.length >0){
              for(var i = 0;i<res.pathList.length;i++){
                this.images += res.pathList[i]+','
              }
            }else{
              this.images = ''
            }
            this.getAfterOrderLogistics();
          })
          .catch(err => {
            console.log(err);
          });
      },

      getAfterOrderLogistics(){
        getAfterOrderLogistics({externalLoginKey:getStore('externalLoginKey'),orderId:this.orderId,productId:this.productId,reasonId:this.currentReasonId,detail:this.$refs.detailReason.value,imgUrl:this.images,partyName:this.$refs.partyName.value,phone:this.$refs.phone.value,typeId:this.typeId,quantity:this.quantity,orderItemSeqId:this.orderItemSeqId})
          .then(res => {
            console.log("getAfterOrderLogistics")
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_)
            } else {
              Toast('提交成功')
              this.$router.back(-1)
            }
            setTimeout(() => {
              this.showLoading = false
            }, 1000);
          })
          .catch(err => {
            console.log(err);
          });
      },

      commitApplyInfo() {
        // 数字商品逻辑
        debugger
        if (this.isReturns == 'N') {
          if (this.currentReasonId == '') {
            Toast('请选择退货原因')
          } else {
            this.showLoading = true
            var fileName = "";
            for(var i = 0;i<this.fileList.length;i++){
              fileName += this.fileList[i].file.name+","+this.fileList[i].content.substring(this.fileList[i].content.indexOf(',')+1,this.fileList[i].content.length) + ','
            }
            // 判断图片非必选
            if (this.fileList.length > 0) {
              this.upload(fileName);
            } else {
              this.images = ''
              this.getAfterOrderLogistics();
            }
          }
        } else if (this.isReturns == 'Y') {
          // 普通商品逻辑

          // if (this.fileList.length == 0 ) {
          //   Toast('请上传图片')
          // } else

          if (this.currentReasonId == '') {
            Toast('请选择退货原因')
          } else if (this.$refs.partyName.value == '') {
            Toast('请填写退货人姓名')
          } else if (this.$refs.phone.value == '') {
            Toast('请填写退货人手机号')
          } else {
            this.showLoading = true
            if (this.fileList.length > 0) {
              var fileName = "";
              for(var i = 0;i<this.fileList.length;i++){
                fileName += this.fileList[i].file.name+","+this.fileList[i].content.substring(this.fileList[i].content.indexOf(',')+1,this.fileList[i].content.length) + ','
              }
              this.upload(fileName);
            } else {
              this.images = ''
              this.getAfterOrderLogistics();
            }

          }
        }
      },

      // 数据格式化
      resetScorllView() {
        this.$router.afterEach((to,from, next) => {
          window.scrollTo(0,0)
        })
      },
    },

    mounted(){
      this.initData();
      this.resetScorllView();
    },
  }
</script>

<style>
  .after-commit-content{
    width:100%;
  }
  .after-commit-each{
    width:100%;
    background-color: white;
  }
  .after-commit-goods{
    width:100%;
  }
  .after-commit-goods-each{
    width:100%;
    padding-bottom: 0.9375rem;
    padding-top: 0.9375rem;
    border-bottom: 1px solid #eee;
  }
  .after-commit-goods-left{
    display: inline-block;
    vertical-align: top;
    height: 5rem;
    margin-left: 1rem;
    margin-right:0.6875rem;
  }
  .after-commit-goods-left .van-image{
    width:5rem;
    height: 5rem;
  }
  .after-commit-goods-right{
    width:calc(100% - 8rem);
    display: inline-block;
    vertical-align: top;
  }
  .after-commit-goods-name{
    font-size: 0.875rem;
    color:#333;
    line-height: 1.25rem;
    width:14rem;
    display: inline-block;
    vertical-align: top;
  }
  .after-commit-goods-num{
    float: right;
    vertical-align: top;
    color:#33312E;
    font-size: 0.9375rem;
  }
  .after-commit-goods-div-bottom{
    width:100%;
    height: 1.875rem;
    line-height: 1.875rem;
    margin-top: 1rem;
  }
  .after-commit-goods-price{
    color:#EB84AB;
    font-size: 1rem;
    display: inline-block;
    vertical-align: top;
  }
  .after-commit-goods-div-bottom button{
    float: right;
    width:3.75rem;
    height: 1.40625rem;
    line-height: 1.40625rem;
    border-radius: 0.703125rem;
    color:#EB84AB;
    font-size: 0.75rem;
    text-align: center;
    border: 1px solid #EB84AB;
    padding: 0;
  }
  .after-commit-div{
    width:100%;
    height: 3.4375rem;
    line-height: 3.4375rem;
    border-bottom: 1px solid #eee;
  }
  .after-commit-div-title{
    display: inline-block;
    vertical-align: top;
    margin-left: 1rem;
    font-size: 0.8125rem;
    color:#33312E;
  }
  .after-commit-div-value{
    display: inline-block;
    vertical-align: top;
    float: right;
    margin-right: 1rem;
  }
  .after-commit-div-value-select{
    width:6.25rem;
    height:1.875rem;
    font-size: 0.8125rem;
    color:#999;
    border: 1px solid #E7E7E7;
    border-radius: 0.5rem;
    background-color: white;
  }
  .after-commit-div-value-div{
    display: inline-block;
    vertical-align: top;
    width:1rem;
    height: 1.5625rem;
    line-height: 1.5625rem;
    text-align: center;
    color:#33312E;
    font-size: 0.75rem;
    margin-top: 0.8rem;
  }
  .after-commit-div-value-button{
    width:1.875rem;
    height: 1.5625rem;
    border-radius: 0.125rem;
    background-color: #F5F5F5;
    color:#ddd;
    line-height: 1.5625rem;
    display: inline-block;
    vertical-align: top;
    padding: 0;
    margin-top: 0.8rem;
  }
  .after-commit-upload{
    width:100%;
    border-bottom: 1px solid #eee;
  }
  .after-commit-upload-div{
    width:21.4375rem;
    margin: 1rem auto;
  }
  .after-commit-reason{
    width:100%;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 0.5rem;
    border: 1px solid #E7E7E7;
    background-color: white;
    font-size: 0.8125rem;
    color:#333312;
  }
  .after-commit-text{
    background-color: #F8F8F8;
    padding: 1rem;
    color: #999;
    font-size: 0.8125rem;
    border-radius: 0.5rem;
    height: 8.3125rem;
    border: 0;
    width:19.5rem;
  }
  .after-commit-photo-title{
    color:#666;
    font-size: 0.8125rem;
  }
  .after-commit-photo-list{
    width:100%;
    margin-top: 1rem;
  }
  .after-commit-info{
    width:21.4375rem;
    margin: 0 auto 5rem;
  }
  .after-commit-info-div{
    width:100%;
    height: 2rem;
    line-height: 2rem;
    margin-top: 1rem;
  }
  .after-commit-info-title{
    color:#333;
    font-size: 0.8125rem;
    display: inline-block;
    vertical-align: top;
    width:2rem;
    text-align: center;
  }
  .after-commit-info-value{
    width:18.5rem;
    height: 1.5rem;
    display: inline-block;
    vertical-align: top;
  }
  .after-commit-info-value input{
    width:100%;
    height: 100%;
    font-size: 0.725rem;
    color:#666666;
    border: 1px solid #eee;
    border-radius: 0.5rem;
    padding-left: 0.5rem;
    height: 1.5rem;
    line-height: 1.5rem;
  }

  .after-commit-info-value input::-webkit-input-placeholder{
    line-height: normal ;
    padding-top: 3px;
  }

  .after-commit-button{
    width:100%;
    height: 4rem;
    background-color: white;
    position: fixed;
    bottom: 0;
  }
  .after-commit-button button{
    width:19.375rem;
    height: 2.75rem;
    line-height: 1.75rem;
    color:white;
    font-size: 1rem;
    text-align: center;
    background-color: #EB84AB;
    border-radius: 1.375rem;
    margin: 0.8rem 2rem;
  }

  .open_btn {
    width: 1.25rem;
    height: 1.25rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/after/afterCommit.vue